// Datas sempre no fuso da operação, independente do relógio do computador que
// acessa o painel. Duas armadilhas justificam isso:
//   - toISOString() converte para UTC e, das 21h em diante, devolve o dia seguinte;
//   - o relógio do PC do caixa pode estar desregulado ou em outro fuso.
const TIMEZONE = 'America/Sao_Paulo';

const formatter = new Intl.DateTimeFormat('en-CA', {
  timeZone: TIMEZONE,
  year: 'numeric', month: '2-digit', day: '2-digit',
  hour: '2-digit', minute: '2-digit', second: '2-digit',
  hourCycle: 'h23',
});

const partsOf = value => {
  const date = value ? new Date(value) : new Date();
  if (Number.isNaN(date.getTime())) return null;
  return formatter.formatToParts(date).reduce((acc, part) => {
    acc[part.type] = part.value;
    return acc;
  }, {});
};

// 'AAAA-MM-DD' do dia corrente na operação
export const isoDate = value => {
  const p = partsOf(value);
  return p && `${p.year}-${p.month}-${p.day}`;
};

// 'AAAA-MM' do mês corrente na operação
export const isoMonth = value => {
  const p = partsOf(value);
  return p && `${p.year}-${p.month}`;
};
